import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useFormContext } from 'react-hook-form-mui';
import RenderSelectField from '../../../../Utilities/Forms/RenderSelectField';
import RenderTextField from '../../../../Utilities/Forms/RenderTextField';
import ValidatedSelectElement from '../../../../Utilities/Forms/ValidatedSelectElement';
import ValidatedTextField from '../../../../Utilities/Forms/ValidatedTextField';
import monthDropdown from '../../../../Utilities/Constants/MonthDropdown';
import yesNoDropdown from '../../../../Utilities/Constants/YesNoDropdown';
interface IProps {
    isReadOnly: boolean
}
export default function TravelPlanCarSharingV1({ isReadOnly }: IProps) {

    const { getValues } = useFormContext();
    const formValues = getValues();
    const hasValues = (fields: string[]) => fields.some(field => formValues[field]) || !isReadOnly;

    return (
        <>
            <Grid container alignItems="flex-start">
                <Grid size={4} container>
                    {hasValues(["matchingSystemForCarSharing", "matchingSystemForCarSharingMonth", "matchingSystemForCarSharingYear", "matchingSystemForCarSharingCapitalCost", "matchingSystemForCarSharingAnnualCost"]) && (
                        <Grid container size={12} >
                            <RenderSelectField name="matchingSystemForCarSharing" label="Car-share matching system where employer takes active role in setting up car-share teams (i.e more than just a voluntary noticeboard)" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'matchingSystemForCarSharingMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'matchingSystemForCarSharingYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="matchingSystemForCarSharingCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="matchingSystemForCarSharingAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                        </Grid>
                    )}

                    {hasValues(["priorityParkingSpacesForCarSharers", "priorityParkingSpacesForCarSharersMonth", "priorityParkingSpacesForCarSharersYear", "priorityParkingSpacesForCarSharersCaptialCost", "priorityParkingSpacesForCarSharersAnnualCost"]) && (
                        <Grid container size={12} >
                            <RenderSelectField name="priorityParkingSpacesForCarSharers" label="Priority parking spaces for car-sharers close to building entrance" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'priorityParkingSpacesForCarSharersMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'priorityParkingSpacesForCarSharersYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="priorityParkingSpacesForCarSharersCaptialCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="priorityParkingSpacesForCarSharersAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                        </Grid>
                    )}
                </Grid>

                <Grid size={4} container>
                    {hasValues(["guaranteedFreeRideHomeForEmergencies", "guaranteedFreeRideHomeForEmergenciesMonth", "guaranteedFreeRideHomeForEmergenciesYear", "guaranteedFreeRideHomeForEmergenciesCapitalCost", "guaranteedFreeRideHomeForEmergenciesAnnualCost"]) && (
                        <Grid container size={12} >
                            <RenderSelectField name="guaranteedFreeRideHomeForEmergencies" label="Guaranteed free ride home available to all staff if they car-share and need to get home in an emergency" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'guaranteedFreeRideHomeForEmergenciesMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'guaranteedFreeRideHomeForEmergenciesYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="guaranteedFreeRideHomeForEmergenciesCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="guaranteedFreeRideHomeForEmergenciesAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                        </Grid>
                    )}

                    {hasValues(["localCarClubAvailable", "siteOperatedOrIndependantCarClubAvailable"]) && (
                        <Grid container size={12} >
                            <RenderSelectField name="localCarClubAvailable" label="Car Club available locally that could be used by occupants of the site" readOnly={isReadOnly} options={yesNoDropdown} />
                            <RenderSelectField name="siteOperatedOrIndependantCarClubAvailable" label="Does the site operate its own Car Club or subscribe to an independent Car Club organisation?" readOnly={isReadOnly} options={yesNoDropdown} />
                        </Grid>
                    )}
                </Grid>

                <Grid size={4} container>
                    <Grid container size={12} >
                        <Grid size={12}>
                            <Typography variant={"h6"}>Additional comments</Typography>
                        </Grid>
                        <RenderTextField name="carSharingComments" readOnly={isReadOnly} multiLine={true} rows={4} inputSize={12} alwaysShow={true} />
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}
